import angular from "angular";

angular
    .module('ui-sentinel.sentry-reports')
    .controller('SentryReportsByList', SentryReportsByList);

SentryReportsByList.$inject = ['$rootScope', '$scope', '$state', '$filter', '$q', 'SentinelUiSession', 'UomSecondsConverter', 'FeedbackService', 'SentryAdminApiService', 'SentryAccountApiService'];

function SentryReportsByList($rootScope, $scope, $state, $filter, $q, SentinelUiSession, UomSecondsConverter, FeedbackService, SentryAdminApiService, SentryAccountApiService) {
    const vm = {
        currentTab: "params",
        sentryText: null,
        command: null,
        imeiData: new Map(),
        results: [],
        isProcessing: false,
        configBy: 'list',
        clear: clear,
        firmwareToMatch: "",
        from: moment().subtract(24, 'hour').startOf('minute').format('YYYY-MM-DDTHH:mm:00'),
        to: moment().startOf('minute').format('YYYY-MM-DDTHH:mm:00'),
        reportNumberMin: 1,
        gpsLocationMin: 1,
        storeAndForwardRatio: 75,
        batteryMin: 95,
        rssiMin: -10,
        lightMin: 1,
        pressureMin: 97,
        pressureMax: 102,
        temperatureMin: 18,
        temperatureMax: 40,
        humidityMin: 20,
        humidityMax: 80,
        temperatureProbe1Min: "",
        temperatureProbe1Max: "",
        extSwitchToMatch: "",
        logRetrieverCheck: false,
        batchCountMin: 1,
        bleFwToMatch: "0209",
        wifiFwToMatch: "",
        loraFwToMatch: "",
        atRestModeCheck: false,
        atRestIntervalSecondsToMatch: 3600,
        inMotionIntervalSecondsToMatch: 900,
        shockEnabledCheck: false,
        shockThresholdMin: "",
        customerConfigToMatch: "00",
        selectBy: 'hours',
        hoursSinceNow: 24,
        goToDeviceReports: goToDeviceReports,
        displayValue: displayValue,
        cellStyle: cellStyle,
        exportFileName: exportFileName,
        secondsService: UomSecondsConverter,
        goToParams: goToParams,
        feedback: FeedbackService,
        goToSentries: goToSentries,
        goToResults: goToResults,
        start: start,
        list: []
    };

    activate();
    return vm;

    function activate() {
        vm.feedback.clear();
    }

    function clear() {
        vm.sentryText = null;
        vm.list = [];
    }

    function isV2() {
        return $state.current && $state.current.name === 'sentry-reports-by-list-v2';
    }

    function displayValue(v) {
        return (v === null || v === undefined || v === '') ? '?' : v;
    }

    function cellStyle(v) {
        if (v === true) {
            return { 'background-color': '#dff0d8', 'box-shadow': 'none' };
        }
        if (v === false) {
            return { 'background-color': '#f2dede', 'box-shadow': 'none' };
        }
        return {};
    }

    function exportFileName() {
        return 'sentry-checks-v2-' + moment().format('YYYY-MM-DD-HH_mm');
    }

    function goToParams() {
        vm.currentTab = 'params';
    }


    function goToSentries() {
        vm.currentTab = 'sentries';
    }

    function goToResults() {
        if (vm.list) {
            vm.currentTab = 'results';
        }
    }

    function start() {
        if (vm.configBy === 'list' && !vm.sentryText) {
            return;
        }
        if (vm.selectBy === 'hours' && !vm.hoursSinceNow) {
            return;
        }
        if (vm.selectBy === 'range' && !vm.from && !vm.to) {
            return;
        }
        if (vm.configBy !== 'list') {
            return;
        }

        vm.imeiList = _.split(vm.sentryText, '\n')
            .map(function (s) { return s.trim(); })
            .filter(function (s) { return s.length > 0; });

        vm.results = vm.imeiList.map(buildEmptyResultRow);
        vm.currentTab = 'results';

        if (vm.selectBy === 'hours') {
            vm.to = moment().toISOString();
            vm.from = moment().subtract(vm.hoursSinceNow, 'hours').toISOString();
        }

        processAllImeis().then();
    }

    function buildEmptyResultRow(imei) {
        return {
            imei: imei,
            grade: null,
            reports: null,
            gps: null,
            storeAndForward: null,
            battery: null,
            light: null,
            pressure: null,
            temperature: null,
            humidity: null,
            temperatureProbe1: isTemperatureProbe1TestSkipped() ? true : null,
            extSwitch: !vm.extSwitchToMatch ? true : null,
            logRetriever: !vm.logRetrieverCheck ? true : null,
            batchCount: isBatchCountTestSkipped() ? true : null,
            bleFw: !vm.bleFwToMatch ? true : null,
            wifiFw: !vm.wifiFwToMatch ? true : null,
            loraFw: !vm.loraFwToMatch ? true : null,
            atRestMode: !vm.atRestModeCheck ? true : null,
            atRestInterval: isAtRestIntervalTestSkipped() ? true : null,
            inMotionInterval: isInMotionIntervalTestSkipped() ? true : null,
            shockEnabled: !vm.shockEnabledCheck ? true : null,
            shockThreshold: isShockThresholdTestSkipped() ? true : null,
            customerConfig: !vm.customerConfigToMatch ? true : null,
            firmware: !vm.firmwareToMatch ? true : null,
            reportsValue: null,
            batteryValue: null,
            lightValueDisplay: null,
            pressureValue: null,
            temperatureValue: null,
            humidityValue: null,
            probeTempValue: null,
            atRestIntervalSecondsValue: null,
            inMotionIntervalSecondsValue: null,
            shockThresholdValue: null,
            batchCountValue: null,
            bleFwValue: null,
            wifiFwValue: null,
            loraFwValue: null,
            customerConfigValue: null,
            firmwareValue: null
        };
    }

    async function processAllImeis() {
        vm.isProcessing = true;
        for (let i = 0; i < vm.imeiList.length; i++) {
            const imei = vm.imeiList[i];
            try {
                const data = await getDataForImei(imei);
                vm.imeiData.set(imei, data);
                const report = calculateReportPropertiesForImei(imei, i);
                vm.results[i] = report;
            } catch (e) {
                console.error('processing imei failed', imei, e);
            }
            $rootScope.$applyAsync();
        }
        vm.isProcessing = false;
        $rootScope.$applyAsync();
    }

    async function getDataForImei(imei) {
        const v2 = isV2();
        const isAdmin = SentinelUiSession.user.isAnAdmin;

        const listPromise = isAdmin
            ? SentryAdminApiService.listSentry500SentinelReportsByDevice(SentinelUiSession.focus, imei, vm.from, vm.to, 1).$promise
            : SentryAccountApiService.listSentry500SentinelReportsByDevice(imei, vm.from, vm.to, 1).$promise;

        const needSentry = v2 && vm.logRetrieverCheck;
        const needConfig = !!vm.firmwareToMatch ||
            (v2 && (!isBatchCountTestSkipped() || !!vm.bleFwToMatch || !!vm.wifiFwToMatch || !!vm.loraFwToMatch ||
                vm.atRestModeCheck || !isAtRestIntervalTestSkipped() || !isInMotionIntervalTestSkipped() ||
                vm.shockEnabledCheck || !isShockThresholdTestSkipped() || !!vm.customerConfigToMatch));

        const sentryPromise = needSentry
            ? (isAdmin
                ? SentryAdminApiService.getSentry(imei).$promise
                : SentryAccountApiService.getSentry(imei).$promise)
            : $q.resolve(null);

        const configPromise = needConfig
            ? (isAdmin
                ? (v2
                    ? SentryAdminApiService.getConfigApn(SentinelUiSession.focus, SentinelUiSession.focus.id, imei).$promise
                    : SentryAdminApiService.getConfig(SentinelUiSession.focus, SentinelUiSession.focus.id, imei).$promise)
                : SentryAccountApiService.getConfig(imei).$promise)
            : $q.resolve(null);

        const swallow = function (p) {
            if (!p || typeof p.then !== 'function') return $q.resolve(null);
            return p.then(function (r) { return r; }, function () { return null; });
        };

        const results = await $q.all([swallow(listPromise), swallow(sentryPromise), swallow(configPromise)]);

        return {
            reports: results[0],
            sentry: results[1],
            config: results[2]
        };
    }

    function calculateReportPropertiesForImei(imei) {
        const report = {imei};
        const data = vm.imeiData.get(imei);

        if (!data.reports || data.reports.length === 0) {
            report.reports = false;
            report.gps = false;
            report.storeAndForward = false;
            report.battery = false;
            report.light = false;
            report.pressure = false;
            report.temperature = false;
            report.humidity = false;
            report.temperatureProbe1 = isTemperatureProbe1TestSkipped() ? true : false;
            report.extSwitch = !vm.extSwitchToMatch ? true : false;
        } else {
            report.reports = validateReports(data);
            report.gps = validateGps(data);
            report.storeAndForward = validateStoreAndForward(data);
            report.battery = validateBattery(data);
            report.light = validateLight(data);
            report.pressure = validatePressure(data);
            report.temperature = validateTemperature(data);
            report.humidity = validateHumidity(data);
            report.temperatureProbe1 = validateTemperatureProbe1(data);
            report.extSwitch = validateExtSwitch(data);
        }

        report.firmware = validateFirmware(data);
        if (isV2()) {
            report.logRetriever = validateLogRetriever(data);
            report.batchCount = validateBatchCount(data);
            report.bleFw = validateBleFw(data);
            report.wifiFw = validateWifiFw(data);
            report.loraFw = validateLoraFw(data);
            report.atRestMode = validateAtRestMode(data);
            report.atRestInterval = validateAtRestInterval(data);
            report.inMotionInterval = validateInMotionInterval(data);
            report.shockEnabled = validateShockEnabled(data);
            report.shockThreshold = validateShockThreshold(data);
            report.customerConfig = validateCustomerConfig(data);
        } else {
            report.logRetriever = true;
            report.batchCount = true;
            report.bleFw = true;
            report.wifiFw = true;
            report.loraFw = true;
            report.atRestMode = true;
            report.atRestInterval = true;
            report.inMotionInterval = true;
            report.shockEnabled = true;
            report.shockThreshold = true;
            report.customerConfig = true;
        }

        report.reportsValue = getReportsValue(data);
        report.batteryValue = getBatteryValue(data);
        report.lightValueDisplay = getLightDisplayValue(data);
        report.pressureValue = getRangeValue(data, 'pressureValue');
        report.temperatureValue = getRangeValue(data, 'temperatureValueC');
        report.humidityValue = getRangeValue(data, 'humidity');
        report.probeTempValue = getRangeValue(data, 'temperatureProbe1C', '-');
        report.firmwareValue = getFirmwareValue(data);
        if (isV2()) {
            report.atRestIntervalSecondsValue = getAtRestIntervalSecondsValue(data);
            report.inMotionIntervalSecondsValue = getInMotionIntervalSecondsValue(data);
            report.shockThresholdValue = getShockThresholdValue(data);
            report.batchCountValue = getBatchCountValue(data);
            report.bleFwValue = getBleFwValue(data);
            report.wifiFwValue = getWifiFwValue(data);
            report.loraFwValue = getLoraFwValue(data);
            report.customerConfigValue = getCustomerConfigValue(data);
        }

        report.grade = report.reports &&
            report.gps &&
            report.storeAndForward &&
            report.battery &&
            report.light &&
            report.pressure &&
            report.temperature &&
            report.humidity &&
            report.temperatureProbe1 &&
            report.extSwitch &&
            report.firmware &&
            report.logRetriever &&
            report.batchCount &&
            report.bleFw &&
            report.wifiFw &&
            report.loraFw &&
            report.atRestMode &&
            report.atRestInterval &&
            report.inMotionInterval &&
            report.shockEnabled &&
            report.shockThreshold &&
            report.customerConfig;

        return report;
    }

    function validateReports(data) {
        return data.reports.length >= vm.reportNumberMin;
    }

    function validateFirmware(data) {
        if (!vm.firmwareToMatch)
            return true;

        if (!data.config || !data.config.applicationVersion)
            return false;

        return data.config.applicationVersion.toUpperCase() === vm.firmwareToMatch.toUpperCase();
    }

    function validateGps(data) {
        let count = 0;
        _.forEach(data.reports, function (report) {
            if (report.locationMethod === 'Gps')
                count++;
        });
        return count >= vm.gpsLocationMin;
    }

    function validateStoreAndForward(data) {
        let count = 0;
        _.forEach(data.reports, function (report) {
            if (!report.isStoreAndForward) {
                count++;
            }
        });
        const ratio = count / data.reports.length;
        return ratio >= vm.storeAndForwardRatio / 100;
    }

    function validateBattery(data) {
        let result = true;
        _.forEach(data.reports, function (report) {
            if (report.battery < vm.batteryMin) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validateLight(data) {
        let result = false;
        _.forEach(data.reports, function (report) {
            if (report.lightValue >= vm.lightMin) {
                result = true;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validatePressure(data) {
        let result = true;
        _.forEach(data.reports, function (report) {
            if (report.pressureValue < vm.pressureMin || report.pressureValue > vm.pressureMax) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validateTemperature(data) {
        let result = true;
        _.forEach(data.reports, function (report) {
            if (report.temperatureValueC < vm.temperatureMin || report.temperatureValueC > vm.temperatureMax) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validateHumidity(data) {
        let result = true;
        _.forEach(data.reports, function (report) {
            if (report.humidity < vm.humidityMin || report.humidity > vm.humidityMax) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function isTemperatureProbe1TestSkipped() {
        return vm.temperatureProbe1Min === "" || vm.temperatureProbe1Min === null ||
            vm.temperatureProbe1Max === "" || vm.temperatureProbe1Max === null;
    }

    function validateTemperatureProbe1(data) {
        if (isTemperatureProbe1TestSkipped())
            return true;

        let result = true;
        _.forEach(data.reports, function (report) {
            if (report.temperatureProbe1C < vm.temperatureProbe1Min || report.temperatureProbe1C > vm.temperatureProbe1Max) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validateExtSwitch(data) {
        if (!vm.extSwitchToMatch)
            return true;

        const expected = vm.extSwitchToMatch.toUpperCase();
        let result = true;
        _.forEach(data.reports, function (report) {
            const actual = report.extSwitch ? report.extSwitch.toUpperCase() : null;
            if (actual !== expected) {
                result = false;
                return false; //exit the loop
            }
        });
        return result;
    }

    function validateLogRetriever(data) {
        if (!vm.logRetrieverCheck) {
            return true;
        }
        if (!data.sentry) {
            return false;
        }
        return !!data.sentry.logRetriever;
    }

    function isBatchCountTestSkipped() {
        return vm.batchCountMin === "" || vm.batchCountMin === null || vm.batchCountMin === undefined;
    }

    function validateBatchCount(data) {
        if (isBatchCountTestSkipped()) {
            return true;
        }
        if (!data.config) {
            return false;
        }
        return data.config.batchCount >= vm.batchCountMin;
    }

    function validateBleFw(data) {
        if (!vm.bleFwToMatch) {
            return true;
        }
        if (!data.config || !data.config.apnPassword) {
            return false;
        }
        const expected = ' ' + vm.bleFwToMatch + ' ' + vm.bleFwToMatch;
        const actual = data.config.apnPassword.substring(11, 21);
        return actual === expected;
    }

    function validateWifiFw(data) {
        if (!vm.wifiFwToMatch)
            return true;
        if (!data.config || !data.config.apnPassword)
            return false;
        const actual = data.config.apnPassword.substring(22, 26);
        return actual === vm.wifiFwToMatch;
    }

    function validateLoraFw(data) {
        if (!vm.loraFwToMatch)
            return true;
        if (!data.config || !data.config.apnUsername)
            return false;
        const first = data.config.apnUsername.substring(0, 6);
        const second = data.config.apnUsername.substring(7, 13);
        return first === vm.loraFwToMatch && second === vm.loraFwToMatch;
    }

    function validateAtRestMode(data) {
        if (!vm.atRestModeCheck)
            return true;
        if (!data.config)
            return false;
        return String(data.config.wakeOnVibration).toUpperCase() === 'ENABLED';
    }

    function isAtRestIntervalTestSkipped() {
        return vm.atRestIntervalSecondsToMatch === "" || vm.atRestIntervalSecondsToMatch === null || vm.atRestIntervalSecondsToMatch === undefined;
    }

    function isInMotionIntervalTestSkipped() {
        return vm.inMotionIntervalSecondsToMatch === "" || vm.inMotionIntervalSecondsToMatch === null || vm.inMotionIntervalSecondsToMatch === undefined;
    }

    function validateAtRestInterval(data) {
        if (isAtRestIntervalTestSkipped())
            return true;
        if (!data.config)
            return false;
        return data.config.extendedPeriodicReportInterval === vm.atRestIntervalSecondsToMatch;
    }

    function validateInMotionInterval(data) {
        if (isInMotionIntervalTestSkipped())
            return true;
        if (!data.config)
            return false;
        return data.config.standardPeriodicReportInterval === vm.inMotionIntervalSecondsToMatch;
    }

    function isShockThresholdTestSkipped() {
        return !vm.shockEnabledCheck ||
            vm.shockThresholdMin === "" || vm.shockThresholdMin === null || vm.shockThresholdMin === undefined;
    }

    function validateShockEnabled(data) {
        if (!vm.shockEnabledCheck)
            return true;
        if (!data.config)
            return false;
        return data.config.shockAlarmEnabled === true;
    }

    function validateShockThreshold(data) {
        if (isShockThresholdTestSkipped())
            return true;
        if (!data.config)
            return false;
        return data.config.shockThreshold >= vm.shockThresholdMin;
    }

    function validateCustomerConfig(data) {
        if (!vm.customerConfigToMatch)
            return true;
        if (!data.config || !data.config.apnPassword)
            return false;
        const actual = data.config.apnPassword.substring(27, 29);
        return actual === vm.customerConfigToMatch;
    }

    function getReportsValue(data) {
        return data.reports ? data.reports.length : 0;
    }

    function getDefinedValues(data, field) {
        if (!data.reports || data.reports.length === 0) return [];
        const values = [];
        for (const report of data.reports) {
            const v = report[field];
            if (v !== undefined && v !== null) values.push(v);
        }
        return values;
    }

    function getBatteryValue(data) {
        if (!data.reports || data.reports.length === 0) return '-';
        const values = getDefinedValues(data, 'battery');
        return values.length ? Math.min.apply(null, values) : null;
    }

    function getLightDisplayValue(data) {
        if (!data.reports || data.reports.length === 0) return '-';
        const values = getDefinedValues(data, 'lightValue');
        return values.length ? Math.max.apply(null, values) : null;
    }

    function getRangeValue(data, field, emptyPlaceholder) {
        if (!data.reports || data.reports.length === 0) return '-';
        const values = getDefinedValues(data, field);
        if (!values.length) return emptyPlaceholder !== undefined ? emptyPlaceholder : null;
        const min = Math.min.apply(null, values);
        const max = Math.max.apply(null, values);
        return min + ' – ' + max;
    }

    function getAtRestIntervalSecondsValue(data) {
        return data.config ? data.config.extendedPeriodicReportInterval : null;
    }

    function getInMotionIntervalSecondsValue(data) {
        return data.config ? data.config.standardPeriodicReportInterval : null;
    }

    function getShockThresholdValue(data) {
        const v = data.config ? data.config.shockThreshold : null;
        return (v === null || v === undefined) ? '-' : v;
    }

    function getBatchCountValue(data) {
        return data.config ? data.config.batchCount : null;
    }

    function getBleFwValue(data) {
        return data.config && data.config.apnPassword ? data.config.apnPassword.substring(11, 21) : null;
    }

    function getWifiFwValue(data) {
        return data.config && data.config.apnPassword ? data.config.apnPassword.substring(22, 26) : null;
    }

    function getCustomerConfigValue(data) {
        return data.config && data.config.apnPassword ? data.config.apnPassword.substring(27, 29) : null;
    }

    function getLoraFwValue(data) {
        if (!data.config || !data.config.apnUsername) return null;
        return data.config.apnUsername.substring(0, 6) + ' / ' + data.config.apnUsername.substring(7, 13);
    }

    function getFirmwareValue(data) {
        return data.config ? data.config.applicationVersion : null;
    }


    function goToDeviceReports(item) {
        if (item.reports) {
            $state.go('sentry-reports.by-device', {
                imei: item.imei,
                to: vm.to,
                from: vm.from,
                referrer: 'sentry-reports-by-list'
            });
        }
    }
}
